/** @ignore *//** */
const config = {
  version: '2.17.2',
  type: 'js'
};

export default config;
